"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const DescriptionRowWeb = ({ description }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: "details" });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "description", children: [(0, jsx_runtime_1.jsx)("p", { className: "subtitle-bold", children: t("desc") }), (0, jsx_runtime_1.jsx)("div", { className: "box", children: (0, jsx_runtime_1.jsx)("p", { className: "text-detail", children: description ? description :
                        t('no-description') }) })] }));
};
exports.default = DescriptionRowWeb;
